module.exports = __webpack_public_path__ + "static/img/arrow_768.614dbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/arrow_768.png
// module id = Awcg
// module chunks = 0